var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c("gg-card-title", [_vm._v(" Promotions ")]),
      _c(
        "v-card",
        {
          staticClass: "app-card"
        },
        [
          _c(
            "v-card-text",
            [
              _c(
                "gg-loading",
                {
                  attrs: {
                    loading: _vm.loading,
                    type: "table"
                  }
                },
                [
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.promotions,
                      "sort-by": "promo_request_id",
                      "sort-desc": "",
                      "footer-props": {
                        itemsPerPageOptions: _vm.pagination
                      }
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "item.promo_request_id",
                        fn: function fn(_ref) {
                          var item = _ref.item
                          return [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to: "/promotions/view/".concat(
                                    item.promo_request_id
                                  )
                                }
                              },
                              [
                                _c("strong", [
                                  _vm._v("#" + _vm._s(item.promo_request_id))
                                ])
                              ]
                            )
                          ]
                        }
                      },
                      {
                        key: "item.promo_status",
                        fn: function fn(_ref2) {
                          var item = _ref2.item
                          return [
                            _c(
                              "v-icon",
                              {
                                staticClass: "pb-1",
                                attrs: {
                                  small: "",
                                  color: _vm.statusColor(item.promo_status)
                                }
                              },
                              [_vm._v("mdi-circle")]
                            ),
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.statusNameFormatter(item.promo_status)
                                ) +
                                " "
                            )
                          ]
                        }
                      },
                      {
                        key: "item.actions",
                        fn: function fn(_ref3) {
                          var item = _ref3.item
                          return [
                            _c(
                              "gg-btn",
                              {
                                attrs: {
                                  to: "/promotions/view/".concat(
                                    item.promo_request_id
                                  )
                                }
                              },
                              [_vm._v(" View Details ")]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }